import React, { useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntity } from './met-disease-treatment-type.reducer';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const MetDiseaseTreatmentTypeDetail = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  const metDiseaseTreatmentTypeEntity = useAppSelector(state => state.metDiseaseTreatmentType.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="metDiseaseTreatmentTypeDetailsHeading">
          <Translate contentKey="almobadaraMasterDataApp.metDiseaseTreatmentType.detail.title">MetDiseaseTreatmentType</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{metDiseaseTreatmentTypeEntity.id}</dd>
          <dt>
            <span id="code">
              <Translate contentKey="almobadaraMasterDataApp.metDiseaseTreatmentType.code">Code</Translate>
            </span>
          </dt>
          <dd>{metDiseaseTreatmentTypeEntity.code}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="almobadaraMasterDataApp.metDiseaseTreatmentType.name">Name</Translate>
            </span>
          </dt>
          <dd>{metDiseaseTreatmentTypeEntity.name}</dd>
          <dt>
            <span id="nameAr">
              <Translate contentKey="almobadaraMasterDataApp.metDiseaseTreatmentType.nameAr">Name Ar</Translate>
            </span>
          </dt>
          <dd>{metDiseaseTreatmentTypeEntity.nameAr}</dd>
          <dt>
            <span id="nameEn">
              <Translate contentKey="almobadaraMasterDataApp.metDiseaseTreatmentType.nameEn">Name En</Translate>
            </span>
          </dt>
          <dd>{metDiseaseTreatmentTypeEntity.nameEn}</dd>
          <dt>
            <span id="status">
              <Translate contentKey="almobadaraMasterDataApp.metDiseaseTreatmentType.status">Status</Translate>
            </span>
          </dt>
          <dd>{metDiseaseTreatmentTypeEntity.status}</dd>
        </dl>
        <Button tag={Link} to="/met-disease-treatment-type" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/met-disease-treatment-type/${metDiseaseTreatmentTypeEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default MetDiseaseTreatmentTypeDetail;
